module.exports = __webpack_public_path__ + "static/illustration-c471529e8ea594b688a6b8ecc08cc47c.svg";